module.exports = "/images/9fefe086a3f1deace14b4d1b8e8572c0.svg";